// extracted by mini-css-extract-plugin
export default {"errorMessage":"style-module--errorMessage--00497"};